import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import Home from './views/Home.vue'
import Tarifs from './views/Tarifs.vue'
import Contact from './views/Contact.vue'
import Temoignages from './views/Temoignages.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/temoignages',
      name: 'temoignages',
      component: Temoignages
    },
    {
      path: '/tarifs',
      name: 'tarifs',
      component: Tarifs
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ]
})
